// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2tb1wJcHx{cursor:pointer}@media screen and (-ms-high-contrast: active){._2tb1wJcHx{color:buttonText}._2tb1wJcHx:focus{outline:2px dotted buttonText}}\n", ""]);
// Exports
exports.locals = {
	"fake-button": "_2tb1wJcHx",
	"fakeButton": "_2tb1wJcHx"
};
module.exports = exports;
